import React, { useState } from "react";
import axios from "../../../../Utils/axios";
import { Button, Typography, Alert } from "@mui/material";
import { Form, FormGroup, Col, Input } from "reactstrap";
import pin from "../../../../Assets/images/icon-pin-matching-plat.png";
import phone from "../../../../Assets/images/icon-phone-matching-plat.png";
import mail from "../../../../Assets/images/icon-email-matching-plat.png";
import facebook from "../../../../Assets/images/facebook-matching-plat.png";
import instagram from "../../../../Assets/images/instagram-matching-plat.png";
import linkedin from "../../../../Assets/images/linkedin-matching-plat.png";
import { useTranslation, Trans } from "react-i18next";
import "./ContactForm.css";
import "bootstrap/dist/css/bootstrap.min.css";
//import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import "bootstrap/dist/css/bootstrap.min.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    tel: "",
    email: "",
    content: "",
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const { t } = useTranslation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("/public/s/c/contact", formData);
      console.log(response.data); // Assuming your backend responds with a message
      // Handle success or display a success message to the user
      setFormSubmitted(true);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      console.error(error);
      // Handle error or display an error message to the user
    }
  };

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <div>
      <section className="bg-section">
        <div className="class-row">
          <div className="col-7 contact-form">
            <div className="mt-5-margin adjust-form-class">
              <Typography
                variant="h3"
                sx={{
                  color: "var(--taupe-fonc, #3F4C52)",
                  textAlign: "left",
                  fontFamily: "DM Serif Display",
                  fontSize: {
                    xs: "4.5vw",
                    sm: "2.5vw",
                    md: "2.5vw",
                    lg: "2.5vw",
                    xl: "2.5vw",
                  },
                  fontStyle: "normal",
                  fontWeight: 400,
                }}>
                {t("contactTitle")}
              </Typography>
              <br></br>
              <Form onSubmit={handleSubmit}>

                {/* New Service Type Dropdown */}
                <FormGroup row>
                  {/* <Col xs={6} sm={6} md={12} lg={12} xl={12}>
                    <Input
                      id="service_type"
                      name="service_type"
                      type="select"
                      onChange={handleChange}
                      value={formData.service_type}
                      className="responsive-select"
                      style={{
                        boxShadow: "rgb(185 200 255 / 7%) -7px 14px 20px 20px",
                      }}>
                      <option value="">Sélectionnez le type de service</option>
                      <option value="Service client">Service client</option>
                      <option value="Service commercial">
                        Service commercial
                      </option>
                      <option value="Service réclamation">
                        Service réclamation
                      </option>
                    </Input>
                  </Col> */}
                </FormGroup>
                <FormGroup row>
                  <Col sm={12}>
                    <Input
                      id="name"
                      name="name"
                      placeholder={t("formName")}
                      type="text"
                      onChange={handleChange}
                      className="custom-input" // Add this custom class
                      value={formData.name}
                      style={{
                        backgroundColor: "#F9F9F6",
                        border: "none"
                      }}
                    />
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Col sm={12}>
                    <Input
                      id="tel"
                      name="tel"
                      placeholder={t("formPhone")}
                      type="phone"
                      onChange={handleChange}
                      className="custom-input" // Add this custom class
                      value={formData.tel}
                      style={{
                        backgroundColor: "#F9F9F6",
                        border: "none"
                      }}
                    />
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Col sm={12}>
                    <Input
                      id="email"
                      name="email"
                      placeholder={t("formEmail")}
                      type="email"
                      onChange={handleChange}
                      className="custom-input" // Add this custom class
                      value={formData.email}
                      style={{
                        backgroundColor: "#F9F9F6",
                        border: "none"
                      }}
                    />
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Col sm={12}>
                    <Input
                      id="content"
                      name="content"
                      type="textarea"
                      placeholder={t("formMessage")}
                      onChange={handleChange}
                      className="custom-input" // Add this custom class
                      value={formData.content}
                      style={{
                        backgroundColor: "#F9F9F6",
                        border: "none"
                      }}
                    />
                  </Col>
                </FormGroup>
                <Button
                  type="submit"
                  sx={{
                    backgroundColor: "#4AAE9B",
                    fontFamily: "Lato",
                    textTransform: "none",
                    color: "white",
                    padding: "10px 20px",
                    float: "right",
                    fontSize: {
                      xs: "13px",
                      sm: "14px",
                      md: "15px",
                      lg: "18px",
                      xl: "18px",
                    },
                    borderRadius: "30px",
                    transition: "background-color 0.3s ease", // smooth transition
                    '&:hover': {
                      backgroundColor: "#A8C9B0", // darker or different shade on hover
                    },
                  }}
                >
                  {t("sendMessage")}
                </Button>
              </Form>

              {formSubmitted && (
                <div style={{ marginTop: "20px" }}>
                  <Alert severity="success">
                    {t("messageSent")}
                  </Alert>
                  {refreshPage()}{" "}
                  {/* Refresh the page when alert is displayed */}
                </div>
              )}
            </div>
          </div>

          <div className="col-5 class-col-boudoir">
            <div className="container adjust-coordonnes-class">
              <Typography
                variant="h3"
                sx={{
                  color: "var(--taupe-fonc,rgb(255, 255, 255))",
                  textAlign: "left",
                  fontFamily: "DM Serif Display",
                  fontSize: {
                    xs: "4.5vw",
                    sm: "2.5vw",
                    md: "2.5vw",
                    lg: "2.5vw",
                    xl: "2.5vw",
                  },
                  fontStyle: "normal",
                  fontWeight: 400,
                }}>
                <Trans
                  i18nKey="faqQuestion"
                  components={{ 1: <br /> }}
                />

              </Typography>
              <br></br>
              <Typography
                variant="p"
                sx={{
                  color: "var(--taupe-fonc,rgb(255, 255, 255))",
                  textAlign: "left",
                  fontFamily: "Lato",
                  fontSize: {
                    xs: "1vw",
                    sm: "1vw",
                    md: "1vw",
                    lg: "1vw",
                    xl: "1vw",
                  },
                  fontStyle: "normal",
                  fontWeight: 400,
                }}>
                <Trans
                  i18nKey="contactSubtitle"
                  components={{ 0: <br />, 2: <br /> }}
                />              </Typography>
              <br></br><br></br>
              <div>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                  <img src={pin} className="icon-box" alt="address" style={{ marginRight: "10px" }} />
                  <p style={{ color: "white", fontFamily: "Lato", margin: 0, fontSize: "18px" }}>
                    Perpignan, France
                  </p>
                </div>

                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                  <img src={phone} className="icon-box" alt="phone" style={{ marginRight: "10px" }} />
                  <p style={{ color: "white", fontFamily: "Lato", margin: 0, fontSize: "18px" }}>
                    +33 (0) 6 60 22 71 75
                  </p>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <img src={mail} className="icon-box" alt="email" style={{ marginRight: "10px" }} />
                  <p style={{ color: "white", fontFamily: "Lato", margin: 0, fontSize: "18px" }}>
                    contact@yanacom.fr
                  </p>
                </div>
              </div>
              <div
                style={{
                  paddingTop: "30px",
                  display: "flex",
                  gap: "20px", // ← controls spacing
                  alignItems: "center",
                }}
              >
                <a href="https://www.facebook.com/Yanacom/?locale=fr_FR" target="_blank" rel="noopener noreferrer">
                  <img src={facebook} className="icon-box" alt="facebook" />
                </a>
                <a href="https://www.instagram.com/yanacom.agence.web/" target="_blank" rel="noopener noreferrer">
                  <img src={instagram} className="icon-box" alt="instagram" />
                </a>
                <a href=" https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fsarl-yanacom%2Fabout" target="_blank" rel="noopener noreferrer">
                  <img src={linkedin} className="icon-box" alt="linkedin" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-section-mobile">
        <div className="row contact-form">
          <div className="container mt-5 adjust-form-class">
            <Typography
              variant="h3"
              sx={{
                color: "var(--taupe-fonc, #3F4C52)",
                textAlign: "left",
                fontFamily: "DM Serif Display",
                fontSize: {
                  xs: "4.5vw",
                  sm: "2.5vw",
                  md: "2.5vw",
                  lg: "2.5vw",
                  xl: "2.5vw",
                },
                fontStyle: "normal",
                fontWeight: 400,
              }}>
              {t("contactTitle")}

            </Typography>
            <br></br>
            <Form onSubmit={handleSubmit}>

              {/* New Service Type Dropdown */}
              <FormGroup row>
                {/* <Col xs={6} sm={6} md={12} lg={12} xl={12}>
                    <Input
                      id="service_type"
                      name="service_type"
                      type="select"
                      onChange={handleChange}
                      value={formData.service_type}
                      className="responsive-select"
                      style={{
                        boxShadow: "rgb(185 200 255 / 7%) -7px 14px 20px 20px",
                      }}>
                      <option value="">Sélectionnez le type de service</option>
                      <option value="Service client">Service client</option>
                      <option value="Service commercial">
                        Service commercial
                      </option>
                      <option value="Service réclamation">
                        Service réclamation
                      </option>
                    </Input>
                  </Col> */}
              </FormGroup>
              <FormGroup row>
                <Col sm={12}>
                  <Input
                    id="name"
                    name="name"
                    placeholder="Prénom/Nom"
                    type="text"
                    onChange={handleChange}
                    className="custom-input" // Add this custom class
                    value={formData.name}
                    style={{
                      backgroundColor: "#F9F9F6",
                      border: "none"
                    }}
                  />
                </Col>
              </FormGroup>

              <FormGroup row>
                <Col sm={12}>
                  <Input
                    id="tel"
                    name="tel"
                    placeholder="Téléphone"
                    type="phone"
                    onChange={handleChange}
                    className="custom-input" // Add this custom class
                    value={formData.tel}
                    style={{
                      backgroundColor: "#F9F9F6",
                      border: "none"
                    }}
                  />
                </Col>
              </FormGroup>

              <FormGroup row>
                <Col sm={12}>
                  <Input
                    id="email"
                    name="email"
                    placeholder="Email"
                    type="email"
                    onChange={handleChange}
                    className="custom-input" // Add this custom class
                    value={formData.email}
                    style={{
                      backgroundColor: "#F9F9F6",
                      border: "none"
                    }}
                  />
                </Col>
              </FormGroup>

              <FormGroup row>
                <Col sm={12}>
                  <Input
                    id="content"
                    name="content"
                    type="textarea"
                    placeholder="Votre message"
                    onChange={handleChange}
                    className="custom-input" // Add this custom class
                    value={formData.content}
                    style={{
                      backgroundColor: "#F9F9F6",
                      border: "none"
                    }}
                  />
                </Col>
              </FormGroup>
              <Button
                type="submit"
                sx={{
                  backgroundColor: "#4AAE9B",
                  fontFamily: "Lato",
                  textTransform: "none",
                  color: "white",
                  padding: "10px 20px",
                  float: "right",
                  fontSize: {
                    xs: "13px",
                    sm: "14px",
                    md: "15px",
                    lg: "18px",
                    xl: "18px",
                  },
                  borderRadius: "30px",
                  transition: "background-color 0.3s ease", // smooth transition
                  '&:hover': {
                    backgroundColor: "#A8C9B0", // darker or different shade on hover
                  },
                }}
              >
                Envoyer un message
              </Button>
            </Form>

            {formSubmitted && (
              <div style={{ marginTop: "20px" }}>
                <Alert severity="success">
                  Message envoyée avec succès !
                </Alert>
                {refreshPage()}{" "}
                {/* Refresh the page when alert is displayed */}
              </div>
            )}
          </div>
        </div>

        <div className="row">
          <div className="class-col-boudoir">
            <div className="container mt-5 adjust-coordonnes-class">
              <Typography
                variant="h3"
                sx={{
                  color: "var(--taupe-fonc,rgb(255, 255, 255))",
                  textAlign: "left",
                  fontFamily: "DM Serif Display",
                  fontSize: {
                    xs: '6vw', // Font size for extra small screens
                    sm: '6vw', // Font size for small screens
                    md: '6vw', // Font size for medium screens
                    lg: '3.5vw', // Font size for large screens
                    xl: '2.5vw' // Font size for extra large screens
                  },
                  fontStyle: "normal",
                  fontWeight: 400,
                }}>
                Une<br></br> question?
              </Typography>
              <br></br>
              <Typography
                variant="p"
                sx={{
                  color: "var(--taupe-fonc,rgb(255, 255, 255))",
                  textAlign: "left",
                  fontFamily: "Lato",
                  fontSize: {
                    xs: "3vw",
                    sm: "3vw",
                    md: "3vw",
                    lg: "3vw",
                    xl: "3vw",
                  },
                  fontStyle: "normal",
                  fontWeight: 400,
                }}>
                Nous offrons un accompagnement <br></br>personnalisé pour répondre <br></br>à vos besoins spécifiques.
              </Typography>
              <br></br><br></br>
              <div>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                  <img src={pin} className="icon-box" alt="address" style={{ marginRight: "10px" }} />
                  <p style={{ color: "white", fontFamily: "Lato", margin: 0, fontSize: "18px" }}>
                    Perpignan, France
                  </p>
                </div>

                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                  <img src={phone} className="icon-box" alt="phone" style={{ marginRight: "10px" }} />
                  <p style={{ color: "white", fontFamily: "Lato", margin: 0, fontSize: "18px" }}>
                    +33 (0) 6 60 22 71 75
                  </p>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <img src={mail} className="icon-box" alt="email" style={{ marginRight: "10px" }} />
                  <p style={{ color: "white", fontFamily: "Lato", margin: 0, fontSize: "18px" }}>
                    contact@yanacom.fr
                  </p>
                </div>
              </div>
              <div style={{
                paddingTop: "30px",
                display: "flex",
                gap: "20px", // ← controls spacing
                alignItems: "center",
              }}
              >
                <a href="https://www.facebook.com/Yanacom/?locale=fr_FR" target="_blank" rel="noopener noreferrer">
                  <img src={facebook} className="icon-box" alt="facebook" />
                </a>
                <a href="https://www.instagram.com/yanacom.agence.web/" target="_blank" rel="noopener noreferrer">
                  <img src={instagram} className="icon-box" alt="instagram" />
                </a>
                <a href="https://www.linkedin.com/company/yanacom" target="_blank" rel="noopener noreferrer">
                  <img src={linkedin} className="icon-box" alt="linkedin" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
